<template>
    <div>
        <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
            aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Dodaj zapotrzebowanie do istniejącego zamówienia</h5>
                        <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="fw-bold">Zamówienie docelowe</label>
                                    <select class="form-select form-select-sm" v-model="selectedOrderId"
                                        @change="changeOrder">
                                        <option :value="null">
                                            -- Wybierz zamówienie --
                                        </option>
                                        <option v-for="order in order_list" :key="order.id" :value="order.id">
                                            {{ getOrderLabel(order) }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="selectedOrder" class="alert alert-info mt-3 mb-3">
                                Zapotrzebowanie zostanie dodane do:
                                <strong>{{ getOrderLabel(selectedOrder) }}</strong>
                            </div>
                            <div v-if="!formArticles.length" class="alert alert-warning mt-3">
                                Brak artykułów do dodania.
                            </div>
                            <template v-for="(article, idx) in formArticles" :key="article.key">
                                <table v-if="formArticles.length" class="table order-list-table">
                                    <tbody>
                                        <tr>
                                            <td colspan="2" class="position-relative">
                                                <span>#{{ idx + 1 }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="widthFirstTd">Do zapytania ofertowego</td>
                                            <td>{{ article.quote_request?.request_number || '' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="widthFirstTd">Nr katalogowy</td>
                                            <td>{{ article.catalog_number }}</td>
                                        </tr>
                                        <tr>
                                            <td class="widthFirstTd">
                                                Model
                                            </td>
                                            <td>
                                                {{ article.model }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                Opis
                                            </td>

                                            <td>
                                                {{ article.description }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                Ilość zamawiana
                                            </td>

                                            <td>
                                                <div v-if="hasError(`articles.${idx}.quantity_required`)"
                                                    class="text-danger small">
                                                    {{ getErrorMessage(`articles.${idx}.quantity_required`) }}
                                                </div>

                                                <input class="form-control form-control-sm" type="number" step="0.001"
                                                    min="0.001" v-model.number="article.quantity_required" required>
                                            </td>
                                        </tr>
										<tr>
											<td class="widthFirstTd">Waluta</td>
											<td>
												<select class="form-select form-select-sm" v-model.number="article.currency">
													<option v-for="currency in currencys" :key="currency.id" :value="currency.id">
													  {{ currency.name }}
													</option>
												</select>
											</td>
										</tr>
                                        <tr>
                                            <td class="widthFirstTd">
                                                Ostateczny termin dostawy
                                            </td>

                                            <td>
                                                <div v-if="hasError(`articles.${idx}.delivery_date_deadline`)"
                                                    class="text-danger small">
                                                    {{ getErrorMessage(`articles.${idx}.delivery_date_deadline`) }}
                                                </div>

                                                <input class="form-control form-control-sm" type="date"
                                                    v-model="article.delivery_date_deadline" required>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                Producent
                                            </td>

                                            <td>
                                                <template v-if="article.producer_short_name">
                                                    <span class="font-weight-bolder">
                                                        {{ article.producer_short_name }}
                                                    </span>
                                                </template>

                                                <template v-else>
                                                    <i>Brak domyślnego producenta</i>
                                                </template>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                Cena netto
                                            </td>

                                            <td>
                                                <div v-if="hasError(`articles.${idx}.price_netto`)"
                                                    class="text-danger small">
                                                    {{ getErrorMessage(`articles.${idx}.price_netto`) }}
                                                </div>

                                                <input type="number" class="form-control form-control-sm" min="0"
                                                    step="0.01" v-model.number="article.price_netto" required>
                                            </td>
                                        </tr>
                            <tr>
                              <td class="widthFirstTd">Waluta</td>
                              <td>
                                <select
                                  class="form-select form-select-sm"
                                  v-model.number="article.currency"
                                >
                                  <option v-for="currency in currencys" :key="currency.id" :value="currency.id">
                                    {{ currency.name }}
                                  </option>
                                </select>
                              </td>
                            </tr>
                                        <tr>
                                            <td class="widthFirstTd">
                                                Rabat (%)
                                            </td>

                                            <td class="d-flex align-items-center">

                                                <input type="number" class="form-control form-control-sm" min="0"
                                                    step="0.01" v-model.number="article.rabate">

                                                <div class="ms-2 text-nowrap">
                                                    Kwota rabatu:
                                                    {{
                                                        getDiscountAmount(article)
                                                    }}
                                                </div>

                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                VAT
                                            </td>

                                            <td>
                                                <div v-if="hasError(`articles.${idx}.vat`)" class="text-danger small">
                                                    {{ getErrorMessage(`articles.${idx}.vat`) }}
                                                </div>

                                                <input type="number" class="form-control form-control-sm" min="0"
                                                    step="0.01" v-model.number="article.vat" required>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="widthFirstTd">
                                                Wartość netto
                                            </td>

                                            <td>
                                                <input type="number" class="form-control form-control-sm" disabled
                                                    :value="getNettoValue(article)">
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                Wartość brutto
                                            </td>

                                            <td>
                                                <input type="number" class="form-control form-control-sm" disabled
                                                    :value="getBruttoValue(article)">
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="widthFirstTd">
                                                Uwagi do pozycji
                                            </td>

                                            <td>
                                                <input type="text" class="form-control form-control-sm"
                                                    v-model="article.comments">
                                            </td>
                                        </tr>

                                    </tbody>

                                </table>

                            </template>

                            <div v-if="formArticles.length"
                                class="border-top pt-3 mt-3 me-5 d-flex justify-content-end">
                                <div class="fw-bold fs-5">
                                    Podsumowanie netto:
                                    {{
                                        getTotalNetto().toLocaleString('pl-PL', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                    })
                                    }}
                                </div>
                            </div>

                            <div v-if="errorMessage" class="alert alert-danger mt-3 mb-0">
                                {{ errorMessage }}
                            </div>

                        </div>

                    </div>

                    <div class="modal-footer">

                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="processing">
                            <i class="bi bi-x-square me-2"></i>
                            Zamknij
                        </button>

                        <button type="button" class="btn btn-primary" :disabled="!selectedOrderId ||
                            !formArticles.length ||
                            processing ||
                            !isFormValid
                            " @click="addToOrder">

                            <span v-if="processing">
                                <span class="spinner-border spinner-border-sm me-2" role="status"></span>

                                Dodawanie...
                            </span>

                            <span v-else>
                                <i class="bi bi-plus-square me-2"></i>
                                Dodaj do zamówienia
                            </span>

                        </button>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from "bootstrap";
import axios from "axios";

export default {
    props: {
		    currencys: {
        type: Array,
        default: () => []
    },
        order_list: {
            type: Array,
            default: () => []
        },
        selectedItems: {
            type: [Array, Object],
            default: () => []
        },
        context: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            modalObj: null,
            selectedOrderId: null,
            processing: false,
            errorMessage: null,
            errors: {},
            formArticles: []
        };
    },
    computed: {
        articles() {
            if (Array.isArray(this.selectedItems)) {
                return this.selectedItems;
            }
            if (this.selectedItems && Array.isArray(this.selectedItems.articles)) {
                return this.selectedItems.articles;
            }
            return [];
        },
        selectedOrder() {
            if (!this.selectedOrderId) {
                return null;
            }
            return this.order_list.find(
                order => Number(order.id) === Number(this.selectedOrderId)
            ) || null;
        },
        isFormValid() {
            if (!this.selectedOrderId || !this.formArticles.length) {
                return false;
            }
            return this.formArticles.every(article => {
                return Number(article.quantity_required) > 0 &&
                    article.price_netto !== null &&
                    article.price_netto !== '' &&
                    Number(article.price_netto) >= 0 &&
                    article.vat !== null &&
                    article.vat !== '' &&
                    Number(article.vat) >= 0;
            });
        }
    },
    watch: {
        selectedItems: {
            immediate: true,
            deep: true,
            handler() {
                this.prepareArticles();
            }
        }
    },
    mounted() {
        this.modalObj = new Modal(this.$refs.modalEle);
        this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
            this.selectedOrderId = null;
            this.errorMessage = null;
            this.errors = {};
            this.processing = false;
            this.formArticles = [];
            this.$emit('clear-selection');
        });
    },
    methods: {
        prepareArticles() {
            this.formArticles = this.articles.map((article, index) => {
                const articleData = article.article || article;
                return {
                    key: article.id ||
                        article.required_project_items_id ||
                        article.article_id ||
                        index,
                    project_id: article.quote_request?.project_id ||
                        article.project_id ||
                        null,
                    team_name: article.quote_request?.team_name ||
                        article.team_name ||
                        null,
                    article_id: article.article_id ||
                        article.article?.id ||
                        null,
                    quote_request: article.quote_request || null,
                    quote_request_item_id: article.quote_request_item_id || null,
                    quote_request_items: article.quote_request_items || null,
                    required_project_items_id: article.required_project_items_id ??
                        article.id ??
                        null,
                    quantity_required: Number(
                        article.quantityToOrder ??
                        article.quantity_to_order ??
                        article.quantity_required ??
                        0
                    ),
                    delivery_date_deadline: article.delivery_date_deadline || null,
                    producer_id: article.producer_id ||
                        article.article?.producer_id ||
                        null,
					price_netto: articleData.price_netto !== undefined &&
						articleData.price_netto !== null
						? Number(articleData.price_netto)
						: null,
					rabate: article.rabate !== undefined &&
                        article.rabate !== null
                        ? Number(article.rabate)
                        : 0,
                    vat: article.vat !== undefined &&
                        article.vat !== null &&
                        article.vat !== ''
                        ? Number(article.vat)
                        : 23,
                    comments: article.comments || '',
                    catalog_number: articleData.catalog_number || '',
                    model: articleData.model || '',
                    description: articleData.description || '',
					currency: article.currency ?? 0,
                    producer_short_name: articleData.producer?.name ||
                        article.producer_short_name ||
                        article.producer?.name ||
                        ''
                };
            });
        },
        changeOrder() {
            this.errorMessage = null;
            this.errors = {};
            if (!this.selectedOrder) {
                return;
            }
            this.applyOrderDefaults(this.selectedOrder);
        },
applyOrderDefaults(order) {
    const orderItems =
        order.order_lists_items ||
        order.orderListsItems ||
        order.items ||
        order.order_items ||
        [];

    this.formArticles.forEach(article => {
        let sourceItem = null;

        if (Array.isArray(orderItems) && orderItems.length) {
            sourceItem =
                orderItems.find(item =>
                    Number(item.article_id) === Number(article.article_id)
                ) ||
                orderItems[0];
        }

        if (!sourceItem) {
            if (article.vat === null || article.vat === '') {
                article.vat = 23;
            }
            return;
        }

        // NIE NADPISUJEMY price_netto z zamówienia
        // Cena pochodzi z artykułu.

        if (
            sourceItem.currency !== undefined &&
            sourceItem.currency !== null
        ) {
            article.currency = Number(sourceItem.currency);
        }

        if (
            sourceItem.vat !== undefined &&
            sourceItem.vat !== null &&
            sourceItem.vat !== ''
        ) {
            article.vat = Number(sourceItem.vat);
        } else {
            article.vat = 23;
        }

        if (
            sourceItem.rabate !== undefined &&
            sourceItem.rabate !== null
        ) {
            article.rabate = Number(sourceItem.rabate);
        }

        if (sourceItem.delivery_date_deadline) {
            article.delivery_date_deadline =
                this.normalizeDate(sourceItem.delivery_date_deadline);
        }
    });
},
        normalizeDate(value) {
            if (!value) {
                return null;
            }
            if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                return value;
            }
            if (value.length >= 10) {
                const datePart = value.substring(0, 10);
                if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
                    return datePart;
                }
            }
            if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
                const [day, month, year] = value.split('.');
                return `${year}-${month}-${day}`;
            }
            return value;
        },
        getOrderLabel(order) {
            if (order.order_number) {
                return `#${order.order_number}`;
            }
            if (order.number) {
                return `#${order.number}`;
            }
            return `Zamówienie #${order.id}`;
        },
        getDiscountAmount(article) {
            const price = Number(article.price_netto) || 0;
            const quantity = Number(article.quantity_required) || 0;
            const rabate = Number(article.rabate) || 0;
            return (
                price *
                quantity *
                (rabate / 100)
            ).toLocaleString('pl-PL', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        getNettoValue(article) {
            const price = Number(article.price_netto) || 0;
            const quantity = Number(article.quantity_required) || 0;
            const rabate = Number(article.rabate) || 0;
            return Number(
                (
                    price *
                    quantity *
                    (1 - rabate / 100)
                ).toFixed(2)
            );
        },
        getBruttoValue(article) {
            const netto = this.getNettoValue(article);
            const vat = article.vat === null ||
                article.vat === ''
                ? 23
                : Number(article.vat);
            return Number(
                (
                    netto *
                    (1 + vat / 100)
                ).toFixed(2)
            );
        },
        getTotalNetto() {
            return this.formArticles.reduce((total, article) => {
                return total + this.getNettoValue(article);
            }, 0);
        },
        hasError(field) {
            return !!(
                this.errors &&
                this.errors[field]
            );
        },
        getErrorMessage(field) {
            if (!this.errors[field]) {
                return '';
            }
            if (Array.isArray(this.errors[field])) {
                return this.errors[field][0];
            }
            return this.errors[field];
        },
        async addToOrder() {
            if (
                !this.selectedOrder ||
                !this.formArticles.length ||
                this.processing ||
                !this.isFormValid
            ) {
                return;
            }
            this.processing = true;
            this.errorMessage = null;
            this.errors = {};
            const payload = {
                order_id: this.selectedOrder.id,
                articles: this.formArticles.map(article => ({
                    project_id: article.project_id,
                    team_name: article.team_name,
                    article_id: article.article_id,
                    quantity_required: Number(article.quantity_required),
                    producer_id: article.producer_id,
                    delivery_date_deadline: article.delivery_date_deadline,
                    quote_request: article.quote_request,
                    quote_request_item_id: article.quote_request_item_id,
                    quote_request_items: article.quote_request_items,
                    required_project_items_id: article.required_project_items_id,
                    price_netto: Number(article.price_netto),
                    rabate: Number(article.rabate || 0),
					currency: article.currency ?? 0,
                    vat: article.vat === null ||
                        article.vat === ''
                        ? 23
                        : Number(article.vat),
                    comments: article.comments || ''
                })),
                context: this.context
            };
            try {
                const response = await axios.post(
                    route('orderLists.addtostore'),
                    payload
                );
                console.log(
                    'ADD TO ORDER - RESPONSE:',
                    response.data
                );
                this.$emit(
                    'added-success',
                    'Zapotrzebowanie zostało dodane do zamówienia.'
                );
                this.hide();
            } catch (error) {
                console.error(
                    'ADD TO ORDER - ERROR:',
                    error
                );
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors || {};
                    this.errorMessage =
                        'Uzupełnij poprawnie wszystkie wymagane pola.';
                } else {
                    this.errorMessage =
                        error.response?.data?.message ||
                        'Wystąpił błąd podczas dodawania zapotrzebowania do zamówienia.';
                }
                this.$emit(
                    'added-error',
                    this.errorMessage
                );
            } finally {
                this.processing = false;
            }
        },
        show() {
            if (this.modalObj) {
                this.selectedOrderId = null;
                this.errorMessage = null;
                this.errors = {};
                this.processing = false;
                this.prepareArticles();
                this.modalObj.show();
            }
        },
        hide() {
            if (this.modalObj) {
                this.modalObj.hide();
            }
        }
    }
}
</script>

<style scoped>
.widthFirstTd {
    width: 150px;
}

.order-list-table:not(:first-child) {
    border-top: 2px solid #222;
}

.table.order-list-table {
    font-size: 13px;
    margin-bottom: 0.75rem;
}

.table.order-list-table td,
.table.order-list-table th {
    padding: 4px 6px !important;
    vertical-align: middle !important;
}

.table.order-list-table input.form-control-sm,
.table.order-list-table select.form-select-sm {
    padding: 2px 6px;
    height: 28px;
    font-size: 13px;
}

.table.order-list-table .widthFirstTd {
    width: 140px;
    font-weight: 500;
    color: #444;
}

.order-list-table:not(:first-child) {
    border-top: 1px solid #bbb;
    margin-top: 6px;
    padding-top: 4px;
}

h6,
.font-weight-bolder {
    font-size: 13px;
}
</style>